import api from '@/apis'
import { API_PREFIX } from '@/constants'
import type { PaymentMethodItem } from '@/payment/types'

interface PageableResponse<T> {
  content: T[]
  totalElements: number
  totalPages: number
  number: number
  size: number
}

const DEFAULT_PAGE = 0
const DEFAULT_SIZE = 10

/**
 * 등록된 결제수단(카드/계좌) 리스트 조회 — GET /payments/methods.
 *
 * 응답은 Pageable 형태(content + pageable + ...) — 첫 페이지의 content[]만 추출해서 반환.
 * 카드는 최대 10개까지만 등록 가능하므로 page=0&size=10 단일 호출로 전부 커버.
 * 정렬은 백엔드 기본값 사용 (이전에 박혀있던 `orderBy=NEWEST` 는 OAS 미확인 임의 param 이라 제거).
 */
export const apiGetPaymentMethods = async (): Promise<PaymentMethodItem[]> => {
  const data = await api.get<PageableResponse<PaymentMethodItem>>(`${API_PREFIX.PAYMENT}/payments/methods`, {
    params: { page: DEFAULT_PAGE, size: DEFAULT_SIZE },
  })
  return data.content ?? []
}
